import { jsx as _jsx } from "react/jsx-runtime";
import { useFrame } from '@react-three/fiber';
import { memo, useEffect, useMemo } from 'react';
import * as THREE from 'three';
import { clipConnectorSegmentNearEye } from '../_pure/connectorNearEyeClip.js';
import { areRenderPropsValueEqual } from '../_pure/valueEquality.js';
/** Optional presentation policy; ordinary connectors never mount this frame subscriber. */
export const NearEyeClippedConnectorLine = memo(function NearEyeClippedConnectorLine(props) {
    const geometry = useMemo(() => {
        const result = new THREE.BufferGeometry();
        result.setAttribute('position', new THREE.Float32BufferAttribute(new Float32Array(12), 3));
        result.setDrawRange(0, 0);
        return result;
    }, []);
    const eye = useMemo(() => new THREE.Vector3(), []);
    const material = useMemo(() => new THREE.LineBasicMaterial({
        color: props.color, transparent: true, opacity: props.opacity, depthWrite: false,
    }), [props.color, props.opacity]);
    useEffect(() => () => geometry.dispose(), [geometry]);
    useEffect(() => () => material.dispose(), [material]);
    useFrame(({ camera }) => {
        camera.getWorldPosition(eye);
        const segments = clipConnectorSegmentNearEye(props.start, props.end, [eye.x, eye.y, eye.z], props.radius);
        const attribute = geometry.getAttribute('position');
        segments.forEach((point, index) => attribute.setXYZ(index, ...point));
        attribute.needsUpdate = true;
        geometry.setDrawRange(0, segments.length);
    });
    return _jsx("lineSegments", { geometry: geometry, material: material, frustumCulled: false, dispose: null });
}, areRenderPropsValueEqual);
